export const SET_ASSOCIATE_USERS = 'associateUser/SET_ASSOCIATE_USERS';
export const SET_PAGINATION_META = 'associateUser/SET_PAGINATION_META';
export const SET_APPLIED_ASSOCIATE_USER_FILTER =
  'associateUser/SET_APPLIED_ASSOCIATE_USER_FILTER';
